import * as api from "@/api/williams/tests";
import { queryKeys } from "../../queryKeys";
import { TestFilters } from "@/api/williams/tests";
import { useInfiniteQuery } from "react-query";

const PAGE_SIZE = 100;

export function useStandardTestList(filters: Partial<TestFilters> = {}) {
  return useInfiniteQuery({
    queryKey: queryKeys.standardTests.filter(filters),
    queryFn: ({ pageParam = 0 }) => {
      const skip = pageParam * PAGE_SIZE;
      return api.getStandardTestList({ skip, take: PAGE_SIZE, ...filters });
    },
    getNextPageParam: (lastPage, allPages) => {
      if (lastPage.results.length === PAGE_SIZE) {
        return allPages.length;
      }
    },
  });
}
